
<script setup lang="ts">
import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
import AdminSidebar from "@/components/AdminSidebar.vue";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb'
const route = useRoute();

const pathItems = ref<string[]>([])
const currentPage = ref<string | null>(null)
const secondRoute = ref<string | null>(null)

const updateFromPath = (path: string) => {
  pathItems.value = path.split('/').filter(Boolean) // optional: leer entfernen
  currentPage.value = pathItems.value.at(-1) || null
  secondRoute.value = pathItems.value.at(-2) || null
}

// Initial setzen
updateFromPath(route.path)

// Reagieren auf Routenänderung
watch(() => route.path, (newPath) => {
  updateFromPath(newPath)
})

function capitalizeFirstLetter(str: string): string {
  if (!str) return ''
  return str.charAt(0).toUpperCase() + str.slice(1)
}

</script>

<template>
  <SidebarProvider>
    <AdminSidebar />
    <main class="w-full container">
      <div class="flex flex-row items-center pt-2 gap-2">
        <SidebarTrigger  />
        <Breadcrumb>
          <BreadcrumbList>
            <BreadcrumbItem v-if="currentPage !== 'admin'">
              <NuxtLink to="/admin">Admin</NuxtLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator v-if="currentPage !== 'admin'" />
            <BreadcrumbItem v-if="pathItems.length > 2">
              <NuxtLink :to="`/admin/${secondRoute}`">{{capitalizeFirstLetter(secondRoute ?? '')}}</NuxtLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator v-if="pathItems.length > 2" />
            <BreadcrumbPage>{{(currentPage ?? '').replaceAll("-"," ")}}</BreadcrumbPage>
          </BreadcrumbList>
        </Breadcrumb>
      </div>

      

      <slot />
    </main>
  </SidebarProvider>
</template>